import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  MenuItem,
  Menu,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  SwipeableDrawer,
  ListItemIcon,
} from "@material-ui/core";
import { Menu as MenuIcon, AccountCircle, ExitToApp } from "@material-ui/icons";
import { logout } from "../actions";
import getColor from "./getColor";
import stringValues from "./stringValues";
import baseurl from "../api/baseurl";
const drawerWidth = 260;
const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },

  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  title: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },

  drawerDesktop: {
    display: "none",
    flexShrink: 0,
    [theme.breakpoints.up("md")]: {
      display: "block",
      width: drawerWidth,
    },
  },

  drawerPaper: {
    width: drawerWidth,
  },

  drawerPaperDesktop: {
    width: drawerWidth,
    zIndex: 1,
    backgroundColor: "transparent",
    border: 0,
  },

  content: {
    flexGrow: 1,
    paddingTop: 60,
    [theme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
    },
  },
}));

const Navbar = (props) => {
  const { children, logout, profile, auth } = props;
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation().pathname;

  const sideLinks = [
    {
      path: "/",
      name: "Dashboard",
      whiteIcon: "/MenuIcons/dashboardwhite.png",
      blackIcon: "/MenuIcons/dashboardblack.png",
      show: true,
    },
    {
      path: "/sample-entry",
      name: "Sample Entry",
      whiteIcon: "/MenuIcons/sampleentrywhite.png",
      blackIcon: "/MenuIcons/sampleentryblack.png",
      show:
        auth === 2 &&
        profile.role &&
        (profile.role.includes("X") || profile.role.includes("A"))
          ? true
          : false,
    },
    {
      path: "/assign-test",
      name: "Assign Test",
      whiteIcon: "/MenuIcons/assignentrywhite.png",
      blackIcon: "/MenuIcons/assignentryblack.png",
      show:
        auth === 2 &&
        profile.role &&
        (profile.role.includes("X") || profile.role.includes("C"))
          ? true
          : false,
    },
    {
      path: "/my-sample",
      name: "My Sample",
      whiteIcon: "/MenuIcons/samplewhite.png",
      blackIcon: "/MenuIcons/sampleblack.png",
      show:
        auth === 2 &&
        profile.role &&
        (profile.role.includes("X") || profile.role.includes("B"))
          ? true
          : false,
    },
    {
      path: "/sample-test-report",
      name: "Sample Test Report",
      whiteIcon: "/MenuIcons/sampletestrecordwhite.png",
      blackIcon: "/MenuIcons/sampletestrecordblack.png",
      show:
        auth === 2 &&
        profile.role &&
        (profile.role.includes("X") || profile.role.includes("D"))
          ? true
          : false,
    },
    {
      path: "/all-sample-record",
      name: "All Sample Record",
      whiteIcon: "/MenuIcons/allsamplerecordwhite.png",
      blackIcon: "/MenuIcons/allsamplerecordblack.png",
      show:
        auth === 1
          ? true
          : auth === 2 &&
            profile.role &&
            (profile.role.includes("X") || profile.role.includes("F"))
          ? true
          : false,
    },

    {
      path: "/analysis-report",
      name: "Analysis Report",
      whiteIcon: "/MenuIcons/analysisreportwhite.png",
      blackIcon: "/MenuIcons/analysisreportblack.png",
      show:
        auth === 1
          ? true
          : auth === 2 &&
            profile.role &&
            (profile.role.includes("X") || profile.role.includes("E"))
          ? true
          : false,
    },
    {
      path: "/parameter-wise-report",
      name: "Parameter-Wise Report",
      whiteIcon: "/MenuIcons/parameterwisereportwhite.png",
      blackIcon: "/MenuIcons/parameterwisereportblack.png",
      show:
        auth === 1
          ? true
          : auth === 2 &&
            profile.role &&
            (profile.role.includes("X") || profile.role.includes("E"))
          ? true
          : false,
    },
    {
      path: "/laboratory",
      name: "Laboratory Management",
      whiteIcon: "/MenuIcons/laboratorywhite.png",
      blackIcon: "/MenuIcons/laboratoryblack.png",
      show: auth === 1 ? true : false,
    },
    {
      path: "/lab-params-mapping",
      name: "Lab Parameters Mapping",
      whiteIcon: "/MenuIcons/labtesttoolwhite.png",
      blackIcon: "/MenuIcons/labtesttoolblack.png",
      show: auth === 1 ? true : false,
    },
    {
      path: "/source-type",
      name: "Water Source Type",
      whiteIcon: "/MenuIcons/watersourceswhite.png",
      blackIcon: "/MenuIcons/watersourcesblack.png",
      show: auth === 1 ? true : false,
    },
    {
      path: "/user-management",
      name: "User Management",
      whiteIcon: "/MenuIcons/staffmanagementwhite.png",
      blackIcon: "/MenuIcons/staffmanagementblack.png",
      show: auth === 1 ? true : false,
    },
    {
      path: "/default-data",
      name: "Default Data",
      whiteIcon: "/MenuIcons/settingwhite.png",
      blackIcon: "/MenuIcons/settingblack.png",
      show: auth === 1 ? true : false,
    },
  ];

  const renderSideLinks = () => {
    return sideLinks
      .filter((item) => item.show)
      .map((item, index) => (
        <ListItem
          key={item.path}
          style={{
            backgroundColor:
              item.path === "/"
                ? location === "/" && "#fff"
                : location.includes(item.path) && "#fff",
            borderTopLeftRadius: 18,
            borderBottomLeftRadius: 18,
          }}
          button
          onClick={() => {
            setOpenDrawer(false);
          }}
          component={Link}
          to={item.path}
        >
          <ListItemIcon>
            <img
              style={{ width: 20, height: 20 }}
              alt={item.name}
              src={
                item.path === "/"
                  ? location === "/"
                    ? item.blackIcon
                    : item.whiteIcon
                  : location.includes(item.path)
                  ? item.blackIcon
                  : item.whiteIcon
              }
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color="primary"
                style={{
                  fontWeight: 500,
                  color:
                    item.path === "/"
                      ? location === "/"
                        ? "#222"
                        : "#fff"
                      : location.includes(item.path)
                      ? "#222"
                      : "#fff",
                }}
              >
                {item.name}
              </Typography>
            }
          />
        </ListItem>
      ));
  };

  const renderMenu = () => {
    return (
      <Menu
        id="account-menu"
        style={{ marginTop: 30, marginLeft: -40 }}
        anchorEl={openMenu}
        open={Boolean(openMenu)}
        onClose={() => setOpenMenu(false)}
      >
        <MenuItem
          style={{ width: 170, fontWeight: 500 }}
          component={Link}
          to="/account"
          onClick={() => setOpenMenu(false)}
        >
          <AccountCircle style={{ marginRight: 10 }} />
          My Account
        </MenuItem>
        <MenuItem
          style={{ width: 170, fontWeight: 500 }}
          onClick={() => {
            setOpenMenu(false);
            logout();
          }}
        >
          <ExitToApp style={{ marginRight: 10 }} />
          Logout
        </MenuItem>
      </Menu>
    );
  };

  return (
    <div className={classes.grow}>
      <AppBar
        position="fixed"
        style={{
          zIndex: 2,
          boxShadow: "0px 1px 2px #ddd",
          backgroundColor: "#fff",
        }}
      >
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="primary"
            aria-label="open drawer"
            onClick={(e) => {
              setOpenDrawer(true);
            }}
          >
            <MenuIcon />
          </IconButton>

          <Link to="/" style={{ textDecoration: "none" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                alt={stringValues.name}
                src="/logo512.png"
                style={{
                  objectFit: "contain",
                  height: 30,
                  width: 30,
                  border: "1px solid #ddd",
                  borderRadius: "50%",
                }}
              />{" "}
              <Typography
                className={classes.title}
                style={{
                  color: "#000",
                  fontWeight: 600,
                  fontSize: 16,
                  marginLeft: 10,
                }}
              >
                {stringValues.name}
              </Typography>
            </div>
          </Link>
          <div className={classes.grow} />
          <Typography style={{ color: "black", fontWeight: 500 }}>
            {profile.name}
          </Typography>
          <IconButton
            edge="end"
            onClick={(e) => setOpenMenu(e.currentTarget)}
            color="primary"
            style={{ marginRight: 0, marginLeft: 5 }}
          >
            {profile.photo ? (
              <img
                alt={profile.name}
                src={`${baseurl}${profile.photo}`}
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 15,
                  border: `1px solid ${getColor.primary}`,
                  objectFit: "cover",
                }}
              />
            ) : (
              <AccountCircle fontSize="large" />
            )}
          </IconButton>
          {renderMenu()}
        </Toolbar>
      </AppBar>
      <SwipeableDrawer
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader} />
        <List
          style={{
            background: getColor.primary,
            height: "100%",
          }}
        >
          {renderSideLinks()}
        </List>
      </SwipeableDrawer>
      <Drawer
        className={classes.drawerDesktop}
        anchor="left"
        variant="persistent"
        open={true}
        classes={{
          paper: classes.drawerPaperDesktop,
        }}
      >
        <div style={{ height: 54 }} />

        <List
          style={{
            background: getColor.primary,
            height: "100%",
            overflowY: "auto",
          }}
        >
          {renderSideLinks()}
        </List>
      </Drawer>
      <main className={classes.content}>{children}</main>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.profile,
  };
};
export default connect(mapStateToProps, { logout })(Navbar);
